/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';
// import AddressLabelComponent from './address-label';

export interface IAdressDropdown {
    id: string;
    name: string;
    className: string;
    value: string | number;
    // VSI Customaization - START
    // text: string;
    // addClassRequired?: string;
    // VSI Customaization - END
    additionalAddributes?: object;
    displayData: { key?: string | number; value?: string }[];
    onChange(event: React.ChangeEvent<HTMLSelectElement>): void;
}

const getDropdownItem = (key?: string | number, value?: string, selectedValue?: string | number): React.ReactNode => {
    let isSelected: boolean;
    if (typeof (key) === 'number') {
        isSelected = key === selectedValue;
    } else {
        isSelected = typeof (selectedValue) === 'string' && (key || '').toLowerCase() === (selectedValue || '').toLowerCase();
    }

    return (
        <option key={key} value={key} aria-selected={isSelected}>
            {value}
        </option>
    );
};

/**
 * Address dropdown.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressDropdownFunctionComponent: React.FC<IAdressDropdown> = (props: IAdressDropdown) => {
    const {
        id: itemId,
        name,
        className,
        value,
        additionalAddributes,
        displayData,
        onChange
    } = props;

    return (
        <select
            id={itemId}
            className={`${className}__dropdown`}
            name={name}
            value={value}
            onChange={onChange}
            {...(additionalAddributes || {})}
        >
            {displayData && displayData.map(item => (
                getDropdownItem(item.key, item.value, value)
            ))}
        </select>
    );
};

export default AddressDropdownFunctionComponent;
